import { jsonFromPrismaBytes } from "../server/util/prisma";
import type { Rules } from "./rule";

export function getRules(rules: any): Rules {
    return jsonFromPrismaBytes(rules) as Rules;
}
